import { hasValue } from "@root/misc/helpers";
import type { VdaInput } from "@root/misc/types";

const returnOnlyNumeric = (input: string): number => {
  return parseInt(input.replace(/\D/g, ""), 10);
};

/** @param the input data.
 *  @param range optional parameter to specify up to which parts to include, defaults to 3.
 *    The possible values(index starts at 1):
 *      1: 1 to 163
 *      2: 1 to 326
 *      3: 1 to 489
 */
export const vdaParser = (input: string, range: number): VdaInput => {
  const arr = input.split(/\r?\n/);

  const structuredArr: VdaInput = [];

  let activeID: number;
  let itemNumber: number;
  let activeType: "field" | "serie";

  arr.map((item) => {
    if (item.includes("veld")) {
      activeID = returnOnlyNumeric(item) - 1;
      itemNumber = activeID + 1;
      activeType = "field";
      structuredArr[activeID] = {
        itemNumber,
        data: {
          field: [],
          serie: [],
        },
      };

      return item;
    }

    if (item.includes("serie")) {
      activeType = "serie";
      return item;
    }

    if (activeType === "field" && hasValue(structuredArr[activeID])) {
      const data = item.split(" ").filter((e) => e !== "");
      const formattedData = {
        x: data[0],
        y: data[1],
        color: data[2],
        colorText: data[3],
        originalData: item,
      };
      if (data[2] !== "0") {
        structuredArr[activeID].data.field.push(formattedData);
      }
    }

    if (activeType === "serie" && hasValue(structuredArr[activeID])) {
      const data = item.split(" ").filter((e) => e !== "");
      const formattedData = {
        x: data[0],
        y: data[1],
        color: data[2],
        colorText: data[3],
        originalData: item,
      };
      if (data[2] !== "0") {
        structuredArr[activeID].data.serie.push(formattedData);
      }
    }

    return item;
  });

  switch (range) {
    case 1:
      return structuredArr.slice(0, 163);
    case 2:
      return structuredArr.slice(0, 326);
    default:
      return structuredArr;
  }
};
